import { mapState } from "vuex";
import RowItem from "../RowItem";
import { iconColor } from "@/consts/iconColor";
const __default__ = {
  name: "LatestAbsenceInfo",
  components: {
    RowItem
  },
  filters: {
    trim: function (value) {
      if (!value) return "";
      return value.replace(/\s+/, " ");
    },
    mmdd: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.slice(5);
    }
  },
  props: {
    attendances: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: { ...mapState(["me"])
  },
  methods: {
    iconColor
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // import { inject } from "vue";
    // const attendanceMode = inject("attendanceMode");
    // const changeAttendanceMode = () => {
    //   attendanceMode.value = "counter";
    // };
    return {
      __sfc: true,
      RowItem,
      iconColor
    };
  }

});